module.exports = __webpack_public_path__ + "static/bg-55930e0991315337e7e28b1e4bd055e2.png";